import {ITableEntry} from '@api/models/table/table-entry';

export interface ITableData {
  table: ITableEntry[];
  group_name?: string;
  group_char?: string;
  sr_group_id?: string;
}

export enum TableType {
  Total = 'total',
  Home = 'home',
  Away = 'away'
}
